import moment from 'moment';
import { hasInsightsFeature } from 'src/shared/utils/featureHelpers';
import { NewProjectDefinitionFormState } from '../state/newProjectDefinitionSlice';
import { validateSamplingEvent } from '../components/sampling-cadence/samplingCadence.utils';

export type SectionName = 'projectDetails' | 'projectAims' | 'samplingCadence';

export const getSectionErrors = (formState: NewProjectDefinitionFormState, section: SectionName): string[] => {
    const errors: string[] = [];
    const { projectName, country, projectLeadRole, samplingEvents, features } = formState;

    switch (section) {
        case 'projectDetails':
            if (!projectName) errors.push('Project name is required');
            if (!country) errors.push('Sampling country is required');
            if (!projectLeadRole) errors.push('Customer contact job title is required');
            break;

        case 'projectAims':
            // Only validate projectAims if EDNA feature is selected
            // Note: Sample groups and test types are no longer required
            if (hasInsightsFeature(features || [])) {
                // No validation required - sample groups and test types are optional
            }
            break;

        case 'samplingCadence':
            // Only validate sampling cadence if EDNA feature is selected
            if (hasInsightsFeature(features || [])) {
                // Validate existing sampling events if any
                if (samplingEvents.length > 0) {
                    const invalidEvents = samplingEvents
                        .map((event, index) => ({ event, index, validation: validateSamplingEvent(formState, index) }))
                        .filter(({ validation }) => validation.hasError);
                    if (invalidEvents.length > 0) {
                        invalidEvents.forEach(({ index }) => {
                            const eventYear = samplingEvents[index].year || moment(samplingEvents[index].fromDate || new Date()).year();
                            errors.push(`Sampling event in year ${eventYear} has invalid or missing information`);
                        });
                    }
                }
            }
            break;
    }

    return errors;
};
